import { createSelector } from '@ngrx/store';

import { getOnlineOrderState } from '../getOnlineOrderState';

export const getOrderPointsCost = createSelector(getOnlineOrderState, ({ recalculateRequest }) => recalculateRequest.data?.PointsCalculationResult?.PointsCost?.Points);
